import {
  getSubjectSummaryExportCode,
  getSubjectSummaryExportResult,
  getSubjectSummaryList,
} from '../services';

export default {
  namespace: 'projectSubjectSummary',
  state: {},
  effects: {
    // 项目科目汇总列表
    *getSubjectSummaryList({ payload }, { call }) {
      return yield call(getSubjectSummaryList, payload);
    },

    // 汇总导出提交，生成code
    *getSubjectSummaryExportCode({ payload }, { call }) {
      return yield call(getSubjectSummaryExportCode, payload);
    },

    // 获取导出结果
    *getSubjectSummaryExportResult({ payload }, { call }) {
      return yield call(getSubjectSummaryExportResult, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
